import _colorsDict from "../../dict/colors.js";
export default (function insertColorByLine(html, color, line = 'all') {
  if (!html) {
    return '';
  }
  const colorsDict = _colorsDict;
  const {
    toWebColor
  } = colorsDict;
  color = toWebColor(color);
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  const paragraphs = tempDiv.querySelectorAll('p');
  if (line === 'all') {
    paragraphs.forEach(paragraph => {
      paragraph.innerHTML = `<span style="color: ${color}">${paragraph.innerHTML}</span>`;
    });
  } else if (typeof line === 'number') {
    const index = line;
    if (index >= 0 && index < paragraphs.length) {
      paragraphs[index].innerHTML = `<span style="color: ${color}">${paragraphs[index].innerHTML}</span>`;
    }
  }
  return tempDiv.innerHTML;
});